import { FormControl } from '@angular/forms';
import { Item } from '@app/models/item';

export type TVpsType = 'lite' | 'unmanaged' | null;

export interface PriceInformationModel {
  setup_price_excl_vat: number;
  setup_price_incl_vat: number;
  setup_original_price_excl_vat: number;
  setup_original_price_incl_vat: number;
  promotion: number;
}

export interface VPSPackConfigModel {
  id: number;
  cpu: number;
  ram: number;
  hdd?: number;
  prices: {
    monthly: PriceInformationModel;
    yearly?: PriceInformationModel;
    yearly_same_as_monthly?: boolean;
  };
  site_include: number;
  ssl_include: number;
  disk_include: number;
  hosting_include: number;
  snapshot_include: number;
  windowsCompatible?: boolean;
  canBeOrdered?: boolean;
  loading: boolean;
  stared: boolean;
}

export interface VPSStorageConfigModel {
  id: number;
  storage: number;
  prices: {
    monthly: PriceInformationModel;
    yearly?: PriceInformationModel;
    yearly_same_as_monthly?: boolean;
  };
  loading: boolean;
  stared: boolean;
}

export interface VPSStorageConfigSpeModel {
  id: number;
  storage: number;
  storageFC: FormControl;
  prices: {
    monthly: PriceInformationModel;
    yearly?: PriceInformationModel;
    yearly_same_as_monthly?: boolean;
  }[];
  loading: boolean;
  stared: boolean;
  step: number;
  min_value: number;
  max_value: number;
  onChange: any;
  timeout?: any;
}

export interface VpsItem extends Item {
  attributes?: {
    trial?: boolean;
    vps_type?: null | string;
    selected_period?: boolean;
    period?: number;
    disk_size?: number;
    site_number?: number;
    ssl_number?: number;
    hosting_number?: number;
    snapshot_number?: number;
    pack_id?: number;
    domain_name?: string;
    os?: string | null;
    flow?: MODES;
    os_configuration?: any;
    ssh_config?: {
      type?: string;
      key?: string;
      key_validation?: boolean | string;
    };
    location?: number;
  };
  configuration?: {
    prices: {
      dynamic: {
        period: {
          label: string;
          unit: number;
          prices: {
            fixed: PriceModel;
            fixed_before_discount: PriceModel;
            period: {
              monthly: {
                excl_vat: number;
                incl_vat: number;
                vat: number;
                promotion: number;
              };
            };
          };
        }[];
      };
      distribution: {
        linux: {
          [os: string]: DistributionModel[];
        };
        windows: DistributionModel[];
      };
      vps_keys: any[];
      managed: {
        hdd: VpsOptionConfig;
        hosting: VpsOptionConfig;
        packs: {
          cpu_number: number;
          hdd: VpsOptionConfig;
          hosting: VpsOptionConfig;
          price: PriceModel;
          ram_number: number;
          hdd_system_number?: number;
          site: any;
        }[];
        site: VpsOptionConfig;
        ssl: VpsOptionConfig;
        snapshot: VpsOptionConfig;
      }[];
      unmanaged: {
        hdd: VpsOptionConfig;
        spla?: {
          price: PriceModel;
        }[];
        hosting: VpsOptionConfig;
        packs: {
          cpu_number: number;
          hdd: VpsOptionConfig;
          hosting: VpsOptionConfig;
          price: PriceModel;
          ram_number: number;
          hdd_system_number?: number;
          site: any;
        }[];
        site: VpsOptionConfig;
        ssl: VpsOptionConfig;
        snapshot: VpsOptionConfig;
      }[];
    };
    setup?: any;
  };
}

export interface DistributionModel {
  aClouds: string[];
  bBeta: boolean;
  bPassword: boolean;
  bStaff: boolean;
  iId: number;
  sVersion: string;
  bDeprecated?: boolean;
}

export interface VpsOptionConfig {
  max_value: number;
  min_value: number;
  step: number;
  prices?: {
    price: PriceModel;
    before_discount: PriceModel;
    promotion: number;
  }[];
  packs?: number[];
}

export interface PriceModel {
  excl_vat: number;
  incl_vat: number;
  vat: number;
}

export enum MODES {
  cloudAndManaged = 'vps_cloud_and_managed',
  liteAndCloud = 'vps_lite_and_cloud',
  liteOnly = 'vps_lite',
}

export interface VPSConfiguration {
  managed: {
    configs: VPSPackConfigModel[];
    storageConfigs: VPSStorageConfigModel[];
    storageConfigSpe: VPSStorageConfigSpeModel;
    vpsTypeCanBeOrdered?: boolean;
  };
  unmanaged: {
    configs: VPSPackConfigModel[];
    storageConfigs: VPSStorageConfigModel[];
    storageConfigSpe: VPSStorageConfigSpeModel;
    vpsTypeCanBeOrdered?: boolean;
  };
  lite: {
    configs: VPSPackConfigModel[];
    storageConfigs: VPSStorageConfigModel[];
    storageConfigSpe: VPSStorageConfigSpeModel;
    vpsTypeCanBeOrdered?: boolean;
  };
}
